import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import WatchList, { FAVORITE_PLUS_HOVER, FAVORITE_TYPE_WATCHLIST } from 'components/Favorite';
import { noop } from 'helpers/GlobalHelper';
import { isSeries, isTypeSeries } from 'helpers/ContentHelper';
import { getItemBadge } from 'helpers/VideoHelper';
import { SITE_PLATFORM_MOBILE } from 'helpers/BreakpointHelper';
import getFavoriteData from '../../helpers/processor';
import { HoverStateToolTip, Overlay, SimplifiedImage } from '../../components';

import Style from '../../styles/MoreLike.module.scss';

const MoreLike = ({
  breakpoint,
  collectionLength,
  favoritesManager,
  item,
  itemIndex,
  link: route,
  maxItems,
  onPosterClick,
  posterAltText,
  posterImage,
  preventLazyLoad,
  scaleFromLeft,
  scaleFromRight,
  segmentPlaylistButtonAction,
}) => {
  const badge = getItemBadge(item, false, true);
  const [isFavorite, setFavorite] = useState(false);
  const isMobile = breakpoint === SITE_PLATFORM_MOBILE;
  const { description = '', isSeriesDetailAvailable, seriesType } = item;
  const isCollectionSeries = isTypeSeries(_.get(item, '@type', ''));
  const isVideoSeries = isSeries(seriesType);
  const favoriteData = getFavoriteData({ item });
  const favorites = _.get(favoritesManager, 'favorites');
  const isOnlyWatchList = isVideoSeries || isSeriesDetailAvailable === false;
  const name = isVideoSeries && !isCollectionSeries ? _.get(item, 'name') : null;
  const getCarouselPosterClasses = [];

  if (itemIndex === 0 || scaleFromLeft) {
    getCarouselPosterClasses.push(Style.carouselPosterFirst);
  } else if (
    (!isMobile && (itemIndex === maxItems - 1 || scaleFromRight)) ||
    (isMobile && itemIndex === collectionLength - 1)
  ) {
    getCarouselPosterClasses.push(Style.carouselPosterEnd);
    if (item.id === 'seeMore') {
      getCarouselPosterClasses.push(Style.invisible);
    }
  } else {
    getCarouselPosterClasses.push(Style.carouselPoster);
  }

  const posterImageProps = {
    badge,
    breakpoint,
    image: posterImage,
    item,
    onPosterClick,
    posterAltText,
    preventLazyLoad,
    route,
    theme: Style,
  };

  return (
    <div className={classNames(getCarouselPosterClasses)}>
      <SimplifiedImage {...posterImageProps} />
      <Overlay theme={Style}>
        <span className={Style.watchList}>
          <span className={Style.watchListButtonContainer}>
            <WatchList
              type={FAVORITE_TYPE_WATCHLIST}
              stopNavigationOnClick
              manager={favoritesManager}
              iconType={FAVORITE_PLUS_HOVER}
              setFavorite={setFavorite}
              favorites={favorites}
              data={{ ...favoriteData, titleText: name, subtitleText: description }}
              segmentPlaylistButtonAction={segmentPlaylistButtonAction}
            />
          </span>
          <HoverStateToolTip
            theme={Style}
            isFavorited={isFavorite}
            isRightJustified={isOnlyWatchList}
          />
        </span>
      </Overlay>
    </div>
  );
};

export default MoreLike;

MoreLike.defaultProps = {
  breakpoint: null,
  collectionLength: 0,
  favoritesManager: {},
  item: {},
  itemIndex: 0,
  link: null,
  maxItems: 0,
  onPosterClick: noop,
  overlayProps: {},
  posterAltText: '',
  posterImage: null,
  preventLazyLoad: false,
  scaleFromLeft: false,
  scaleFromRight: false,
  segmentPlaylistButtonAction: noop,
};

MoreLike.propTypes = {
  breakpoint: PropTypes.string,
  collectionLength: PropTypes.number,
  favoritesManager: PropTypes.shape({}),
  item: PropTypes.shape({}),
  itemIndex: PropTypes.number,
  link: PropTypes.string,
  maxItems: PropTypes.number,
  onPosterClick: PropTypes.func,
  overlayProps: PropTypes.shape({}),
  posterAltText: PropTypes.string,
  posterImage: PropTypes.string,
  preventLazyLoad: PropTypes.bool,
  scaleFromLeft: PropTypes.bool,
  scaleFromRight: PropTypes.bool,
  segmentPlaylistButtonAction: PropTypes.func,
};
